export default function AiUsesTable({ records = [], startIndex = 0 }) {
  if (!records?.length) {
    return (
      <div className="text-center py-8 lg:py-16 px-4">
        <div className="inline-flex items-center justify-center w-12 h-12 lg:w-16 lg:h-16 rounded-full bg-gray-100 mb-3 lg:mb-4">
          <svg
            className="w-6 h-6 lg:w-8 lg:h-8 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        </div>
        <p className="text-gray-500 font-medium text-sm lg:text-base">
          No AI usage records found
        </p>
        <p className="text-xs lg:text-sm text-gray-400 mt-1">
          Records will appear here once API calls are made
        </p>
      </div>
    );
  }

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const dateOnly = date.toLocaleDateString();
    const timeOnly = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    return { date: dateOnly, time: timeOnly };
  };

  const formatTime = (ms) => {
    if (!ms) return "N/A";
    return `${(ms / 1000).toFixed(2)}s`;
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full divide-y divide-gray-200 text-xs lg:text-sm">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-2 lg:px-4 py-2 lg:py-3 text-left font-semibold text-gray-600 whitespace-nowrap">
              No
            </th>
            <th className="px-2 lg:px-4 py-2 lg:py-3 text-left font-semibold text-gray-600 whitespace-nowrap hidden sm:table-cell">
              Account
            </th>
            <th className="px-2 lg:px-4 py-2 lg:py-3 text-left font-semibold text-gray-600 whitespace-nowrap hidden sm:table-cell">
              Driver
            </th>
            <th className="px-2 lg:px-4 py-2 lg:py-3 text-left font-semibold text-gray-600 whitespace-nowrap">
              Model
            </th>
            <th className="px-2 lg:px-4 py-2 lg:py-3 text-left font-semibold text-gray-600 whitespace-nowrap hidden md:table-cell">
              Type
            </th>
            <th className="px-2 lg:px-4 py-2 lg:py-3 text-left font-semibold text-gray-600 whitespace-nowrap">
              Tokens
            </th>
            <th className="px-2 lg:px-4 py-2 lg:py-3 text-left font-semibold text-gray-600 whitespace-nowrap hidden lg:table-cell">
              Cache
            </th>
            <th className="px-2 lg:px-4 py-2 lg:py-3 text-left font-semibold text-gray-600 whitespace-nowrap">
              Status
            </th>
            <th className="px-2 lg:px-4 py-2 lg:py-3 text-left font-semibold text-gray-600 whitespace-nowrap hidden md:table-cell">
              Time
            </th>
            <th className="px-2 lg:px-4 py-2 lg:py-3 text-left font-semibold text-gray-600 whitespace-nowrap text-right">
              Date
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {records.map((record, index) => (
            <tr
              key={record.id || index}
              className={`hover:bg-gray-50 transition-colors duration-150 ${
                !record.success ? "bg-red-50/50" : ""
              }`}
            >
              <td className="px-2 lg:px-4 py-2 lg:py-3 whitespace-nowrap font-medium text-gray-900">
                {startIndex + index + 1}
              </td>
              <td className="px-2 lg:px-4 py-2 lg:py-3 whitespace-nowrap text-gray-700 hidden sm:table-cell">
                {record.account ? (
                  <div className="text-sm">
                    <div className="font-medium text-gray-900">
                      {record.account.business_name || "N/A"}
                    </div>
                    <div className="text-xs text-gray-500">
                      {record.account.email || "N/A"}
                    </div>
                  </div>
                ) : (
                  <span className="text-sm text-gray-500">N/A</span>
                )}
              </td>
              <td className="px-2 lg:px-4 py-2 lg:py-3 whitespace-nowrap text-gray-700 hidden sm:table-cell">
                {record.driver ? (
                  <div className="text-sm">
                    <div className="font-medium text-gray-900">
                      {record.driver.first_name} {record.driver.last_name}
                    </div>
                    <div className="text-xs text-gray-500">
                      {record.driver.license_number || "N/A"}
                    </div>
                  </div>
                ) : (
                  <span className="text-sm text-gray-500">N/A</span>
                )}
              </td>
              <td className="px-2 lg:px-4 py-2 lg:py-3 whitespace-nowrap text-gray-700">
                <span
                  className="truncate block"
                  title={record.model_name || "N/A"}
                >
                  {record.model_name
                    ?.replace("gemini-", "")
                    ?.substring(0, 10) || "N/A"}
                </span>
              </td>
              <td className="px-2 lg:px-4 py-2 lg:py-3 whitespace-nowrap hidden md:table-cell">
                <span className="px-2 py-1 inline-flex text-xs font-semibold rounded-full bg-blue-100 text-blue-800">
                  {record.request_type?.substring(0, 8) || "N/A"}
                </span>
              </td>
              <td className="px-2 lg:px-4 py-2 lg:py-3 whitespace-nowrap">
                <div>
                  <div className="font-semibold text-gray-900 text-xs lg:text-sm">
                    {record.total_tokens || 0}
                  </div>
                  <div className="text-xs text-gray-500 hidden lg:block">
                    {record.prompt_tokens || 0}↓ {record.completion_tokens || 0}
                    ↑
                  </div>
                </div>
              </td>
              <td className="px-2 lg:px-4 py-2 lg:py-3 whitespace-nowrap hidden lg:table-cell">
                {record.cache_hit ? (
                  <span className="px-2 py-1 inline-flex text-xs font-semibold rounded-full bg-green-100 text-green-800">
                    Yes
                  </span>
                ) : (
                  <span className="px-2 py-1 inline-flex text-xs font-semibold rounded-full bg-gray-100 text-gray-800">
                    No
                  </span>
                )}
              </td>
              <td className="px-2 lg:px-4 py-2 lg:py-3 whitespace-nowrap">
                {record.success ? (
                  <span className="px-2 py-1 inline-flex text-xs font-semibold rounded-full bg-green-100 text-green-800">
                    ✓
                  </span>
                ) : (
                  <span
                    className="px-2 py-1 inline-flex text-xs font-semibold rounded-full bg-red-100 text-red-800 cursor-help"
                    title={record.error_message}
                  >
                    ✗
                  </span>
                )}
              </td>
              <td className="px-2 lg:px-4 py-2 lg:py-3 whitespace-nowrap text-gray-700 hidden md:table-cell text-xs">
                {formatTime(record.response_time_ms)}
              </td>
              <td className="px-2 lg:px-4 py-2 lg:py-3 whitespace-nowrap text-gray-600 text-right text-xs lg:text-sm">
                {(() => {
                  const formatted = formatDate(record.created_at);
                  return typeof formatted === "object" ? (
                    <div className="flex flex-col">
                      <span className="font-medium">{formatted.date}</span>
                      <span className="text-gray-500">{formatted.time}</span>
                    </div>
                  ) : (
                    formatted
                  );
                })()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
